@let gridConfigValue = gridConfig();

@if (gridConfigValue.headerActionAreaComponent) {
  @let headerActionAreaComponent = gridConfigValue.headerActionAreaComponent || null;
  @let headerActionAreaComponentInputs = gridConfigValue.headerActionAreaComponentInputs ? gridConfigValue.headerActionAreaComponentInputs(data()) : {};
  <div class="grid-header-actions-area">
    <ng-container *ngComponentOutlet="headerActionAreaComponent, inputs: headerActionAreaComponentInputs"></ng-container>
  </div>
}

<div class="grid-header-area" id="data-grid-table">
  @for (row of gridConfig().headerConfig.rows; let index = $index; track gridConfig().headerConfig.trackRowsBy(index, row)) {
    <div class="grid-row" [ngClass]="{ 'grid-row-dashed': gridConfig().dashedRows && $odd  }">
      @for (cell of row.cells; let index = $index; track gridConfig().headerConfig.trackCellsBy(index, cell)) {
        <div class="grid-cell" [ngStyle]="{ 'grid-column': cell.colSpan ? 'span' + cell.colSpan : null }" [ngClass]="cell.cellClassSetter && cell.cellClassSetter(null, index)">
          @if (cell.component) {
            <ng-container *ngComponentOutlet="cell.component; inputs: cell.inputs ? cell.inputs(cell, index) : {}"></ng-container>
          } @else {
            <lb-default-grid-header-cell>
              {{ cell.html | gridCellHtml: cell }}
            </lb-default-grid-header-cell>
          }
        </div>
      }
    </div>
  }
</div>

<div class="grid-data-area">
  @if(!isLoading()){
    @for (dataItem of data(); let index = $index; track gridConfig().dataConfig.trackRowsBy(index, dataItem)) {
      @let rowClickHandler = gridConfig().dataConfig.rowClickHandler;
      @let rowRouterLinkHandler = gridConfig().dataConfig.rowRouterLinkHandler;
      @let sharedRowNgClass = { 'clickable': rowClickHandler || rowRouterLinkHandler, 'grid-row-dashed': gridConfig().dashedRows && !$odd };
      @let rowId = gridConfig().dataConfig.trackRowsBy(index, dataItem);
      @if (rowRouterLinkHandler) {
        <a class="grid-row" [routerLink]="rowRouterLinkHandler(dataItem)" [ngClass]="sharedRowNgClass" [id]="rowId">
          <ng-container *ngTemplateOutlet="rowCells; context: { $implicit: dataItem }"></ng-container>
        </a>
      } @else {
        <div class="grid-row" (click)="rowClickHandler && rowClickHandler(dataItem)" [ngClass]="sharedRowNgClass" [id]="rowId">
          <ng-container *ngTemplateOutlet="rowCells; context: { $implicit: dataItem }"></ng-container>
        </div>
      }
    } @empty {
			<span class="md-text-lg-semibold no-items">{{ noItemsMessage() }}</span>
		}

    <ng-template #rowCells let-dataItem>
      @for (cell of adjustDataCells(dataItem); let index = $index; track gridConfig().dataConfig.trackCellsBy(index, cell)) {
        <div class="grid-cell" [ngStyle]="{ 'grid-column': cell.colSpan ? 'span' + cell.colSpan : null }" [ngClass]="cell.cellClassSetter && cell.cellClassSetter(cell.item, index)">
          @if (cell.component) {
            <ng-container *ngComponentOutlet="cell.component; inputs: cell.inputs ? cell.inputs(dataItem, index) : {}"></ng-container>
          } @else {
            <lb-default-grid-data-cell>
              {{ cell.html | gridCellHtml: dataItem }}
            </lb-default-grid-data-cell>
          }
        </div>
      }
    </ng-template>
  } @else {
    <lb-loader [message]="gridConfig().dataConfig.loadingMessage ?? 'Loading...'"></lb-loader>
  }
</div>

@if (gridConfigValue.footerActionAreaComponent) {
  @let footerActionAreaComponent = gridConfigValue.footerActionAreaComponent || null;
  @let footerActionAreaComponentInputs = gridConfigValue.footerActionAreaComponentInputs ? gridConfigValue.footerActionAreaComponentInputs(data()) : {};
  <div class="grid-footer-actions-area">
    <ng-container *ngComponentOutlet="footerActionAreaComponent; inputs: footerActionAreaComponentInputs"></ng-container>
  </div>
}
